import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Highlighter from 'react-highlight-words'
import ReactResizeDetector from 'react-resize-detector'
import { escapeRegexCharacters } from 'shared/utils/stringUtils'

const useStyles = makeStyles({
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    searchTitleText: {
        fontSize: pxToRem(12),
        lineHeight: 1.4,
    },
})

interface SingleLineEllipsisForSearchProps {
    /**
     * Callback for when the truncation state changes.
     */
    onTruncate?: () => void

    /**
     * Text content.
     */
    text: string

    /**
     * Searched text in search bar
     */
    searchText?: string
    /**
     * Default width of highlighted text
     */
    defaultWidth?: string | number
    /**
     * Parameter to defined if element is added in project
     */
    isElementInProject?: boolean
}

/**
 *
 * This component truncates long texts, and shows
 * the full text in a tooltip.
 */
const SingleLineEllipsisForSearch = ({
    onTruncate,
    text = '',
    searchText = '',
    defaultWidth = 200,
    isElementInProject,
}: SingleLineEllipsisForSearchProps) => {
    const classes = useStyles()
    const highlighColorNotInProject = '#0069AA'
    const highlightColorInProject = '#CCEEFF'
    const [divRef, setDivRef] = React.useState<HTMLDivElement | undefined>()
    const [isTruncated, setIsTruncated] = React.useState(false)

    const setRef = (element: HTMLDivElement) => {
        setDivRef(element)
    }

    const handleResize = (width: any) => {
        if (divRef) {
            setIsTruncated(divRef?.scrollWidth > Math.round(width))
            onTruncate?.()
        }
    }

    return (
        <div className={classes.contentDiv}>
            <HoverTooltip text={isTruncated ? text : ''}>
                <div ref={setRef} className={classes.contentDiv}>
                    <span>
                        <Highlighter
                            className={classes.searchTitleText}
                            style={{
                                width: defaultWidth,
                            }}
                            searchWords={
                                searchText
                                    ?.split(' ')
                                    .map((word) => escapeRegexCharacters(word)) ??
                                []
                            }
                            textToHighlight={text}
                            highlightStyle={{
                                backgroundColor: 'transparent',
                                fontWeight: 500,
                                color: isElementInProject
                                    ? highlightColorInProject
                                    : highlighColorNotInProject,
                                padding: 0,
                            }}
                        />
                    </span>
                </div>
            </HoverTooltip>
            {divRef && (
                <ReactResizeDetector
                    handleWidth
                    onResize={handleResize}
                    targetDomEl={divRef}
                />
            )}
        </div>
    )
}

export default SingleLineEllipsisForSearch
